import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentTemplateEditItem extends IEditItem {
    code: string;
    comment: string;
    content: string;
    landscapeOrientation: boolean;
    modifyUser: IModifyUser;
}

export class DocumentTemplateEditItem extends EditItem implements IDocumentTemplateEditItem {
    code: string;
    comment: string;
    content: string;
    landscapeOrientation: boolean;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IDocumentTemplateEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj?.code || "";
        this.comment = obj?.comment || "";
        this.content = obj?.content || "";
        this.landscapeOrientation = obj?.landscapeOrientation || false;
        this.modifyUser = new ModifyUser(obj?.modifyUser);
    }
}